import type React from 'react'
import { type IResourceComponentsProps } from '@refinedev/core'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input } from 'antd'
import { detectPlatform, PLATFORM_HOSTS } from '../../utils/platformUrl'

export const CountryCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps /* queryResult */ } = useForm({
    errorNotification: (error: any) => {
      const status = error?.statusCode ?? error?.response?.status
      const apiError = error?.response?.data?.error
      if (status === 999 || apiError === 'Already Exists') {
        return {
          message: 'Evento già presente',
          description: 'Questo evento è già monitorato. Aprilo dalla lista per modificarlo.',
          type: 'error'
        }
      }
      return {
        message: 'Errore',
        description: apiError ?? error?.message ?? 'Impossibile aggiungere l\'evento',
        type: 'error'
      }
    }
  })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout='vertical'>
        <Form.Item
          label='Event Url'
          name={['url']}
          extra={`Piattaforme supportate: ${Object.keys(PLATFORM_HOSTS).filter(p => p !== 'fansaleEvent').join(', ')}`}
          rules={[
            {
              required: true
            },
            {
              validator: async (_, value) => {
                if (!value) return
                const platform = detectPlatform(value)
                if (!platform) {
                  throw new Error('URL non riconosciuto: hostname non corrisponde a nessuna piattaforma supportata')
                }
              }
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Frequency between each scan in seconds '
          name={['frequency']}
          rules={[
            {
              required: false
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Old Less Than - Only show an alert if there is a variation and the old value is lower of this number'
          name={['oldLessThan']}
          rules={[
            {
              required: false
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Create>
  )
}
